import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { RxHamburgerMenu } from "react-icons/rx/index.esm";
import { FaChevronDown } from "react-icons/fa/index.esm";
import { RiLogoutBoxRLine } from "react-icons/ri/index.esm";
import {
  IoLockClosedOutline,
  IoSettingsOutline,
} from "react-icons/io5/index.esm";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import actions from "../../actions";
import { getAdminDetails, getNotifications, markAsSeenNotifications } from "../../apis";
import "./navbar.css";
import { requestPermission } from "../../config/notification";
import { listenForAllNotifications, listenForNotifications } from "../../config/firebase";
import NotificationPopup from "./NotificationPopUp";

const Navbar = ({
  userDetailsRequest,
  adminDetails,
  activateSidebarRequest,
  deactivateSidebarRequest,
  sidebar,
  logoutRequest,
  stopLoadingRequest,
}) => {
  const dropdownRef = useRef(null);
  const dropdownButtonRef = useRef(null);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [user,setUser] = useState("");
  const [notifications, setNotifications] = useState([]);
  const [allNotifications,setAllNotifications]=useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const unseenCount =allNotifications.length>0&& allNotifications.filter(n => !n.isSeen).length;
  const [soundEnabled, setSoundEnabled] = useState(false);
  const notificationSound = useRef(null);
  useEffect(() => {
  const unlockedBefore = localStorage.getItem("soundUnlocked");
  if (unlockedBefore) setSoundEnabled(true);

  notificationSound.current = new Audio("/notification1.mp3");
  notificationSound.current.volume = 1.0;

  const unlockAudio = () => {
    notificationSound.current.play().then(() => {
      notificationSound.current.pause();
      notificationSound.current.currentTime = 0;
      setSoundEnabled(true);
      localStorage.setItem("soundUnlocked", "true");
      console.log("🔓 Sound unlocked and remembered!");
    });
  };

  if (!unlockedBefore) {
    document.addEventListener("click", unlockAudio, { once: true });
    document.addEventListener("keydown", unlockAudio, { once: true });
  }

  return () => {
    document.removeEventListener("click", unlockAudio);
    document.removeEventListener("keydown", unlockAudio);
  };
}, []);

  const fetch = useCallback(async () => {
    try {
      const apiResponse = await getAdminDetails();
      if (apiResponse?.data?.data?.adminDetails) {
        // userDetailsRequest(apiResponse?.data?.data?.adminDetails);
      }
      stopLoadingRequest();
    } catch (error) {}
  }, []);


  useEffect(() => {
    const storedUserDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (storedUserDetails) {
         userDetailsRequest(storedUserDetails);
         setUser(storedUserDetails)
    }
  }, []);

  useEffect(() => {
    fetch();
  }, []);

  useEffect(() => {
    if (window.innerWidth > 1023) {
      activateSidebarRequest();
    }
  }, []);

  const openSidebarHandler = useCallback(() => {
    if (sidebar) {
      deactivateSidebarRequest();
    } else {
      activateSidebarRequest();
    }
  }, [sidebar]);

  const openDropdownHandler = useCallback(() => {
    setOpenDropdown(!openDropdown);
  }, [openDropdown]);

  useEffect(() => {
    document.addEventListener("click", (event) => {
      if (
        !dropdownButtonRef?.current?.contains(event.target) &&
        !dropdownRef?.current?.contains(event.target)
      ) {
        setOpenDropdown(false);
      }
    });
  }, [dropdownButtonRef, dropdownRef]);

  useEffect(()=>{
    const getNotification = async()=>{
      try {
        const res = await getNotifications();
        setAllNotifications(res?.data?.data)
      } catch (error) {
        console.log("error",error)
      }
    }
    getNotification();
  },[])
  const markAsSeenNotification=async()=>{
    try {
      const res=await markAsSeenNotifications()
      if (res.data?.data) {
        setAllNotifications(res.data.data);
      }
    } catch (error) {
      console.log("error",error)
    }
  }
  useEffect(() => {
    if (showNotifications) {
      // API call to mark all as seen (you must implement this backend)
      markAsSeenNotification();
    }
  }, [showNotifications]);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          console.log("Service Worker registered:", registration);
        })
        .catch((error) => {
          console.error("Service Worker registration failed:", error);
        });
    }
    
    requestPermission();
    
    // Use the enhanced listener that handles both foreground and background
    listenForAllNotifications((newNotification) => {
      // console.log("newNotification",newNotification)
      if (notificationSound.current) {
        notificationSound.current
          .play()
          .catch((err) => console.warn("Sound blocked:", err));
      }
      setNotifications((prev) => [newNotification, ...prev]);
      setAllNotifications((prev)=>[newNotification, ...prev])
    });
  }, [soundEnabled]);
  const removeNotification = (index) => {
    setNotifications((prev) => prev.filter((_, i) => i !== index));
  };
  return (
    <nav>
      <div  style={{zIndex:"1000",position:"fixed",right:"10px",top:"10px"}}>
        {notifications.map((notification, index) => (
          <NotificationPopup
            key={index}
            notification={notification}
            onClose={() => removeNotification(index)}
          />
        ))}
      </div>
      {!soundEnabled && (
        <button
          onClick={() => {
            notificationSound.current
              ?.play()
              .then(() => {
                notificationSound.current.pause();
                notificationSound.current.currentTime = 0;
                setSoundEnabled(true);
              })
              .catch(() => alert("Please click again to enable sound!"));
          }}
          style={{
            padding: "6px 12px",
            borderRadius: "6px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            cursor: "pointer",
          }}
        >
          🔔 Enable Notification Sound
        </button>
      )}
      <div
        ref={dropdownRef}
        className={openDropdown ? "dropdown active" : "dropdown"}
      >
        <Link to="/settings">
          <IoSettingsOutline size={14} />
          Account Settings
        </Link>
        <Link to="/password">
          <IoLockClosedOutline size={14} />
          Change Password
        </Link>
        <button onClick={logoutRequest}>
          <RiLogoutBoxRLine size={14} />
          Logout
        </button>
      </div>
      <div className="left-wrapper">
        <button
          id="hamburger"
          type="button"
          onClick={() => openSidebarHandler()}
        >
          <RxHamburgerMenu id="hamburger-icon" size={22} />
        </button>
        <img src="/images/logo.png" />
      </div>
      <div style={{display:"flex",alignItems:"center",gap:"10px",position:"relative"}}>
        <div style={{position:"relative",cursor:"pointer"}}>
        <img src="/images/bell.png"  onClick={() => setShowNotifications(prev => !prev)} style={{width:"20px",height:"20px",cursor:"pointer"}}/>
        {unseenCount > 0&&<span style={{backgroundColor:"red",margin:"auto",display:"flex",alignItems:"center",justifyContent:"center", color:"white",fontSize:"12px",width:"1rem",height:"1rem",borderRadius:"50%",position:"absolute",top:"-8px",right:"-6px",textAlign:"center"}}>{unseenCount}</span>}
        </div>
        
        <button
        ref={dropdownButtonRef}
        onClick={openDropdownHandler}
        className="right-wrapper"
      >
        {/* <div className="image-wrapper">
          {adminDetails?.data?.image && <img src={adminDetails?.data?.image} />}
        </div> */}
        {/* <span>{`${adminDetails?.data?.firstName} ${adminDetails?.data?.lastName}`}</span> */}
        <span>{`${user?.firstName} ${user?.lastName}`}</span>
        <FaChevronDown size={13} />
      </button>
      {showNotifications && (
  <div
    style={{
      position: "absolute",
      top: "30px",
      right: "0",
      width: "340px",
      background: "#fff",
      border: "1px solid #e0e0e0",
      borderRadius: "10px",
      padding: "12px",
      zIndex: 1001,
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      maxHeight: "500px",
      overflowY: "auto",
    }}
  >
    {/* Close button */}
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
      <h4 style={{ margin: 0 }}>Notifications</h4>
      <button
        onClick={() => setShowNotifications(false)}
        style={{
          background: "transparent",
          border: "none",
          fontSize: "16px",
          cursor: "pointer",
        }}
      >
        ✖
      </button>
    </div>

    {/* Notification List */}
    {allNotifications.length === 0 ? (
      <p style={{ textAlign: "center", color: "#777" }}>No notifications</p>
    ) : (
      allNotifications.map((noti) => (
        <div
          key={noti._id}
          style={{
            display: "flex",
            alignItems: "flex-start",
            backgroundColor: noti.isSeen ? "#f8f9fa" : "#e8f0fe",
            borderRadius: "8px",
            padding: "10px",
            marginBottom: "10px",
            gap: "10px",
          }}
        >
          {/* Bell Icon */}
          <img
            src="/images/bell.png"
            alt="icon"
            style={{ width: "20px", height: "20px", marginTop: "4px" }}
          />

          {/* Notification Content */}
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: "600", marginBottom: "4px", fontSize: "14px" }}>
              {noti.title}
            </div>
            <div style={{ fontSize: "13px", color: "#333", marginBottom: "6px" }}>
              {noti.body}
            </div>
            <small style={{ color: "#999", fontSize: "12px" }}>
            {new Date(noti.createdAt || Date.now()).toLocaleString("en-IN", {
  dateStyle: "medium",
  timeStyle: "short",
})}

            </small>
          </div>

          {/* View Button */}
          <button
            onClick={() => {
              window.location.href = noti.link;
            }}
            style={{
              backgroundColor: "#007bff",
              border: "none",
              color: "white",
              padding: "6px 10px",
              borderRadius: "6px",
              fontSize: "12px",
              cursor: "pointer",
              marginTop: "2px",
            }}
          >
            View
          </button>
        </div>
      ))
    )}
  </div>
)}

      </div>
      
    </nav>
  );
};

const mapStateToProps = (state) => ({
  adminDetails: state.auth,
  sidebar: state.sidebar,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      userDetailsRequest: actions.auth.userDetails,
      deactivateSidebarRequest: actions.sidebar.deactivateSidebar,
      activateSidebarRequest: actions.sidebar.activateSidebar,
      logoutRequest: actions.auth.logout,
      stopLoadingRequest: actions.loader.stopLoading,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
